import { DictionariesCreatePage } from 'features/dictionaries/components/DictionariesCreatePage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesInventoryCreatePage = () => {
  return <DictionariesCreatePage type={DictionaryType.Inventory} />
}
